// NOTICE: KAPTION-INTEGRATION - WhatsApp Template Management Store
import * as types from '../mutation-types';
import WhatsappTemplatesAPI from '../../api/whatsappTemplates';

export const state = {
  records: [],
  languages: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getTemplates($state) {
    return $state.records;
  },
  getLanguages($state) {
    return $state.languages;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }, { inboxId, language, excludeKaption = true } = {}) {
    commit(types.default.SET_WHATSAPP_TEMPLATES_UI_FLAG, {
      isFetching: true,
    });
    try {
      const { data } = await WhatsappTemplatesAPI.getTemplates(inboxId, {
        language,
        excludeKaption,
      });
      commit(types.default.SET_WHATSAPP_TEMPLATES, data.templates);
      commit(types.default.SET_WHATSAPP_TEMPLATES_LANGUAGES, data.languages);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.default.SET_WHATSAPP_TEMPLATES_UI_FLAG, {
        isFetching: false,
      });
    }
  },

  async create({ commit }, { inboxId, templateData } = {}) {
    commit(types.default.SET_WHATSAPP_TEMPLATES_UI_FLAG, {
      isCreating: true,
    });
    try {
      const { data } = await WhatsappTemplatesAPI.createTemplate(
        inboxId,
        templateData
      );
      return data;
    } finally {
      commit(types.default.SET_WHATSAPP_TEMPLATES_UI_FLAG, {
        isCreating: false,
      });
    }
  },
};

export const mutations = {
  [types.default.SET_WHATSAPP_TEMPLATES_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_WHATSAPP_TEMPLATES]($state, templates) {
    $state.records = templates;
  },
  [types.default.SET_WHATSAPP_TEMPLATES_LANGUAGES]($state, languages) {
    $state.languages = languages;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
